import React from 'react';
import classes from 'components/Mobile/components/PageContainer/pageContainer.mobile.module.scss';
import ErrorBoundary from 'components/common/ErrorBoundary/ErrorBoundary';

interface Props {
    children: React.ReactNode;
    isResponsive?: boolean;
    className?: string;
}

export const MobilePageContainer = ({ children, isResponsive = false, className }: Props) => {
    return (
        <div className={`${classes.PageContainerCss} ${isResponsive && classes.responsive} ${className ?? ''}`}>
            <ErrorBoundary pageLevel={true}>{children}</ErrorBoundary>
        </div>
    );
};
